var exports = {
  "zr": "MacPermissionPrompt.module__root___aUxhT2",
  "Vs": "MacPermissionPrompt.module__tile___aUxhT2",
  "DD": "MacPermissionPrompt.module__title___aUxhT2",
  "X7": "MacPermissionPrompt.module__purpose___aUxhT2",
  "vQ": "MacPermissionPrompt.module__purposeLine___aUxhT2",
  "o1": "MacPermissionPrompt.module__actions___aUxhT2",
  "E3": "MacPermissionPrompt.module__primaryActions___aUxhT2",
  "zB": "MacPermissionPrompt.module__primary___aUxhT2",
  "qD": "MacPermissionPrompt.module__notNow___aUxhT2",
  "TQ": "MacPermissionPrompt.module__allowed___aUxhT2",
  "Wy": "MacPermissionPrompt.module__allowedIn___aUxhT2",
};

module.exports = exports;
